var i4_List_editor = {
	instances: {},
	get: function(key) {

		var instance = null;
		if (this.instances[key] === undefined) {
			instance = $.extend({}, i4_List_editor_instance);
			instance.initialize(key);
			this.instances[key] = instance;
		} else {
			instance = this.instances[key];
		}

		return instance;
	}
};

var i4_List_editor_instance = {
	instance_id: '',
	element_result_id: '',
	ajax_parameter: '',
	empty_item: '', // text
	empty_count: 0, // text
	option: {},
	sortable: null, // i4_Sort_instance

	set_element_result_id: function(v) { this.element_result_id = v; return this; },
	set_ajax_parameter: function(v) { this.ajax_parameter = v; return this; },

	set_option: function(option) {
		this.option = $.extend(this.option, option);
		return this;
	},

	initialize: function(instance_id) {
		this.instance_id = instance_id;
		this.element_result_id = '';
		this.ajax = '';

		this.option = {
			image_delete: '',
			image_move: '',
			after_delete_item: function() {},
			after_add_item: function() {},
			after_load: function() {},
			sortable: true
		};
	},

	run: function() {
		$('#'+this.element_result_id).before(
			$('<div></div>').attr('id', 'list_empty_item_tmp_'+this.instance_id).hide()
		);

		i4_Ajax.factory().
			set_id(this.element_result_id).
			set_parameter(jQuery.param(this.ajax_parameter)).
			set_option({
			    on_complete: (function(transport) {
			    	$('#'+this.element_result_id+' > div.ajax_javascript').remove();
			    	$('#'+this.element_result_id+' > div').addClass('i4-form__sortable-list-item');

			    	this.prepair_elements();

			    	if ($('#'+this.element_result_id+' > div').length == 0) {
			    		this.add_item();
			    	} else {
			    		this.generate_item_buttons();
			    		this.set_save_string();
			    	}

			    	this.option.after_load();

			    }).bind(this)
			}).
			run();

		if (this.option.sortable) {
			this.sortable = i4_Sort.factory(this.element_result_id).
				set_handles('list_move_item').
				set_tag('div').
				set_only('i4-form__sortable-list-item').
				set_send_type('post').
				set_new_order_id('list_save_'+this.instance_id);
		}
	},

	prepair_elements: function() {
		$('#'+this.element_result_id).append(
			$('<button></button>').
				attr({
					'id': 'list_add_item_'+this.instance_id,
					'type': 'button'
				}).
				addClass('i4-button i4-button--small').
				text(i4_Translation.get().button_add).
				on('click', (function() {
					this.add_item();
				}).bind(this))
		);

		$('#'+this.element_result_id).append(
			$('<input>').attr({
				id: 'list_save_'+this.instance_id,
				name: 'list_save_'+this.instance_id,
				type: 'hidden'
			})
		);

	},

	generate_item_buttons: function () {
		$('#'+this.element_result_id+' img.list_remove_item').remove();
		$('#'+this.element_result_id+' img.list_move_item').remove();

		var element_count = $('#'+this.element_result_id+' > div').length;
		$('#'+this.element_result_id+' > div').each((function(i, item){

			var $item = $(item);

			$item.find('.i4-form__sortable-list-item-toolbar').remove();

			if (element_count > 1) {
				if (!$item.find('.list_remove_item').length) {

					var $toolbar = $('<div></div>');
					$toolbar.addClass('i4-form__sortable-list-item-toolbar');
					$(item).append($toolbar);
					$toolbar.append(
						$('<img>').
							attr('src', this.option.image_delete).
							addClass('list_remove_item').
							on('click', (function(element) {
								this.remove($(element.target).parents('div.i4-form__sortable-list-item').first().attr('id'));
							}).bind(this)).
							css('cursor', 'pointer')
					);

					if (this.option.sortable) {
						$toolbar.prepend(
							$('<img>').
								attr('src', this.option.image_move).
								addClass('list_move_item')
						);
					}

				}
			}

			if (i+1 == element_count) {
				$item.find('input, select').focus();
			}

		}).bind(this));

		if (this.option.sortable) {
			this.sortable.run();
		}
	},

	add_item: function() {

		i4_Ajax.factory().
			set_id('list_empty_item_tmp_'+this.instance_id).
			set_parameter(jQuery.param(this.ajax_parameter)+'&empty='+this.empty_count).
			set_option({
				on_complete: (function(transport) {
					var $select = $('#list_empty_item_tmp_'+this.instance_id).find('div').first();

					$select.
						addClass('empty_item').
						addClass('i4-form__sortable-list-item');

					$('#list_add_item_'+this.instance_id).before($select);

					this.generate_item_buttons();
					this.set_save_string();

					this.option.after_add_item(this.empty_count);

					this.empty_count++;

				}).bind(this)
			}).
			run();

	},

	set_save_string: function() {
		var save_string = '';
		$('#'+this.element_result_id+' .i4-form__sortable-list-item').each(function(i, item) {
		    var id = $(item).data('id');
		    save_string += ','+id;
		});

		$('#list_save_'+this.instance_id).val(save_string);
	},

	remove: function(id) {
		$('#'+id).remove();
		this.generate_item_buttons();
		this.set_save_string();

		this.option.after_delete_item(id);
	}

};  // i4_List_editor_instance
